import logo from '../assets/images/logo.svg';
import searchIcon from '../assets/icons/search.svg';
import LoginArrow from '../assets/icons/arrow.svg';
import { useState } from 'react';
import { getHomepageUrl } from '../utils/constants';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const homepageUrl = getHomepageUrl();

  return (
    <header className="bg-white border-b border-gray-200 py-4 sticky top-0 z-40">
      <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-40">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {homepageUrl === '/' ? (
              <a href="/" className="flex items-center space-x-3" aria-label="Go to home">
                <img src={logo} alt="BIOWELL Logo" className="h-10 w-auto sm:h-12" />
              </a>
            ) : (
              <a href={homepageUrl} className="flex items-center space-x-3" aria-label="Go to home">
                <img src={logo} alt="BIOWELL Logo" className="h-10 w-auto sm:h-12" />
              </a>
            )}
          </div>

          {/* <nav className="hidden md:flex items-center space-x-8">
            <a
              href="#"
              className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium"
            >
              Products
            </a>
            <a
              href="#"
              className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium"
            >
              About Us
            </a>
            <a
              href="#"
              className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium"
            >
              Contact Us
            </a>
          </nav> */}

          <div className="flex items-center space-x-1 sm:space-x-1.5">
            <button className="p-2 sm:p-3 text-gray-600 hover:text-biowell-green transition-colors rounded-full hover:bg-gray-50">
              <img
                src={searchIcon}
                alt="Search"
                className="w-5 h-5 sm:w-6 sm:h-6"
              />
            </button>
            <button className="p-2 group rounded-full bg-gray-50 w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center">
              <img
                src={LoginArrow}
                alt="Login Arrow"
                className="w-5 h-5 sm:w-6 sm:h-6"
              />
            </button>

            <button
              className="md:hidden p-2 text-gray-600 hover:text-biowell-green transition-colors rounded-full hover:bg-gray-50"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <a
                href="#"
                className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium px-4 py-2"
              >
                Products
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium px-4 py-2"
              >
                About Us
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-biowell-green transition-colors font-poppins font-medium px-4 py-2"
              >
                Contact Us
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
